module.exports = __webpack_public_path__ + "static/img/mission-new-2.54657e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/introduce/mission-new-2.jpg
// module id = tkWr
// module chunks = 1